module.exports = __webpack_public_path__ + "static/media/bridge_unit_german.51d4904b.png";